var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKit = function SvgKit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "kit_svg__path-1",
    cx: 12,
    cy: 12,
    r: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kit_svg__Guidelines",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "kit_svg__export",
    transform: "translate(-218 -251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kit_svg__badges/technology",
    transform: "translate(218 251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kit_svg__Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kit_svg__color/alexs-deep-blue/base-003595"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kit_svg__mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kit_svg__path-1"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kit_svg__path-1",
    id: "kit_svg__Mask",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kit_svg__color/alexs-deep-blue/base-003595(og)",
    fill: "#003996",
    mask: "url(#kit_svg__mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kit_svg__alexs-deep-blue-003595",
    d: "M0 0h24v24H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "kit_svg__noun_medical-kit_3985024",
    fill: "#FFF",
    transform: "translate(3 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kit_svg__Shape",
    fillRule: "nonzero",
    d: "M14.989 2.553h-1.322v-.68c0-.681-.579-1.235-1.29-1.235h-1.434A1 1 0 0 0 10 0H7a1 1 0 0 0-.943.638H4.622c-.71 0-1.289.554-1.289 1.234v.681H2.011C.902 2.553 0 3.417 0 4.48v.947c0 .176.15.319.333.319h1v7.165c0 1.152.98 2.09 2.184 2.09h9.966c1.204 0 2.184-.938 2.184-2.09V5.745h1a.327.327 0 0 0 .333-.32V4.48c0-1.062-.902-1.926-2.011-1.926M7 .638h3c.184 0 .333.143.333.32 0 .175-.15.319-.333.319H7a.327.327 0 0 1-.333-.32c0-.176.15-.319.333-.319M4 1.872a.61.61 0 0 1 .622-.595h1.435A1 1 0 0 0 7 1.915h3a1 1 0 0 0 .943-.638h1.435a.61.61 0 0 1 .622.595v.681H4zM15 12.91c0 .8-.68 1.452-1.517 1.452H3.517C2.68 14.362 2 13.71 2 12.91V5.745h1v.957c0 .176.15.32.333.32h1.334A.326.326 0 0 0 5 6.701v-.957h7v.957c0 .176.15.32.333.32h1.334a.327.327 0 0 0 .333-.32v-.957h1zM4.333 6.383h-.666V4.787h.666zm9 0h-.666V4.787h.666zm3-1.277H14v-.638c0-.176-.15-.32-.333-.32h-1.334a.327.327 0 0 0-.333.32v.638H5v-.638c0-.176-.15-.32-.333-.32H3.333a.326.326 0 0 0-.333.32v.638H.667V4.48c0-.71.603-1.288 1.344-1.288H14.99c.741 0 1.344.578 1.344 1.288z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kit_svg__noun_rna_1512059",
    fill: "#FFF",
    transform: "rotate(90 2 14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kit_svg__Path",
    fillRule: "nonzero",
    d: "M3.542 2.38H.332v.26l.277.253h2.782l-.56.513H1.169l.559.513h.546L0 6.005V9h.458v-.328h3.21V8.16H.457v-.513h3.21v-.513H.457V6.62h3.21v-.26l-.277-.253H.609l.56-.513h1.663l-.559-.513h-.546L4 2.995V0h-.458v.328H.332V.84h3.21v.513H.332v.513h3.21z"
  })))))));
};
export default SvgKit;